import { render, staticRenderFns } from "./image-button.vue?vue&type=template&id=f08abaf8&"
import script from "./image-button.vue?vue&type=script&lang=js&"
export * from "./image-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports